module.exports = __webpack_public_path__ + "static/assets/a8debf706094634d9d5f49690da9cf44.png";